import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Table, Pagination} from 'antd';
@inject('userEmailManagementStore')
@observer
class SearchResult extends Component {
  handlePageChange = (pageNo, pageSize) => {
    const { userEmailManagementStore } = this.props;
    userEmailManagementStore.onChangePageNo(pageNo,pageSize)
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { userEmailManagementStore } = this.props;
    userEmailManagementStore.onChangeSelectedRowKeys(selectedRowKeys,selectedRows)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { userEmailManagementStore} = this.props
    const { pageNo, pageSize, itemCount, showEmailList, selectedRowKeys } = userEmailManagementStore
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
      return (
        <>
          <Table className='searchResult' dataSource={toJS(showEmailList)} rowSelection={rowSelection} pagination={false} rowKey="id" rowClassName={this.getRowClassName} bordered>
              <Table.Column title='Email' dataIndex="address" key="address"/>
          </Table>
          <Pagination
            current={pageNo}
            pageSize={pageSize}
            onChange={this.handlePageChange}
            total={itemCount}
            showSizeChanger
            showQuickJumper
            showTotal={total => `共${total}条数据`}
            pageSizeOptions={['10', '20', '50', '100']}
            style={{marginTop: 16, paddingBottom:16, textAlign: 'right'}}
          />
        </>
      );
  }
}

export default SearchResult;
